import React from "react";
import heroBg from "../Images/About.jpg"; 
import circleImage from "../Images/Para.jpg"; 

const AboutUs = () => {
  return (
    <section className="font-belleza">

      {/* === HERO SECTION === */}
      <div
        className="relative w-full h-[220px] sm:h-[300px] md:h-[350px] bg-cover bg-center flex items-center justify-center text-white"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <div className="bg-black bg-opacity-65 w-full h-full absolute top-0 left-0" />
        <div className="relative z-10 text-center px-4">
          <h1 className="text-3xl sm:text-4xl md:text-5xl text-[#C8C0A7]/90 font-anton">
            ABOUT US
          </h1>
          <p className="text-base sm:text-lg md:text-xl font-anonymous text-[#C8C0A7] mt-2">
            Travel that is transformational.
          </p>
        </div>
      </div>

      {/* === CONTENT CARD === */}
      <div className="max-w-6xl mx-auto mt-8 md:mt-12 bg-white shadow-md p-6 sm:p-8 md:flex md:items-center md:gap-12">
        
        {/* LEFT CIRCLE IMAGE */}
        <div className="w-full md:w-1/2 flex justify-center mb-6 md:mb-0">
          <img
            src={circleImage}
            alt="Aurah Scenic Icon"
            className="w-40 h-40 sm:w-52 sm:h-52 md:w-60 md:h-60 rounded-full object-cover border border-gray-300"
          />
        </div>

        {/* RIGHT TEXT CONTENT */}
        <div className="w-full md:w-1/2 text-left px-2 sm:px-0">
          <h2 className="text-2xl sm:text-3xl text-[#14767E] uppercase tracking-wider font-perandory text-center md:text-left">
            The Heart of Aurah
          </h2>

          <p className="text-gray-800 mt-4 leading-relaxed font-sans text-sm sm:text-base text-justify md:text-left">
            A premium travel management company redefining the way the world journeys.
            With decades of expertise, we specialize in crafting bespoke travel solutions
            for corporate and luxury clientele across both domestic and international sectors.
            Our approach blends personalized service, smart technology, and a deep understanding
            of each traveler’s unique needs.
          </p>

          <p className="text-gray-800 mt-4 leading-relaxed font-sans text-sm sm:text-base text-justify md:text-left">
            We’re not just travel planners — we’re curators of refined experiences. From high level
            business travel to exclusive leisure escapes, every itinerary is designed with precision,
            efficiency, and a touch of indulgence. Our round-the-clock support, cutting-edge reservation
            systems, and longstanding industry partnerships ensure that your journey is seamless,
            sophisticated, and entirely stress-free.
          </p>

          <p className="text-gray-800 mt-4 leading-relaxed font-sans text-sm sm:text-base text-justify md:text-left">
            At Aurah, we believe travel should never feel transactional — it should feel transformational.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
